import { useApplicationStore } from '@data';
import { isAxiosError } from 'axios';

export function getAccessToken() {
  const { auth } = useApplicationStore.getState();
  const { accessToken } = auth;
  return accessToken;
}

function parseAxiosError(error: unknown): string {
  if (isAxiosError(error)) {
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data;
      const serverMessage = parseServerMessage(data);
      return `Upload failed (HTTP ${status}): ${serverMessage}`;
    } else if (error.request) {
      return 'No response from server. Please check your network and try again.';
    } else {
      return `Request error: ${error.message}`;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unknown error occurred while uploading.';
}

function parseServerMessage(data: unknown): string {
  if (data && typeof data === 'object') {
    const maybeObj = data as { message?: string; error?: string };
    if (maybeObj.message) return maybeObj.message;
    if (maybeObj.error) return maybeObj.error;
    return JSON.stringify(data);
  } else if (typeof data === 'string') {
    return data;
  }
  return 'Unknown server error';
}

export { parseAxiosError };
